<template>
    <div class="page white_bg">

        <header class="pageHeader white_bg" style="line-height: 46px;">
            <div class="borderLayout paddingH16">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="height: 46px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">
                        <router-link :to="{name : 'search'}">
                            <i class="icon searchIcon" style="margin-top: 3px;"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </header>

        <div class="body">

            <div class="paddingH16">

                <div class="list">
                    <div class="item" style="margin-bottom: 32px;" v-for="dataItem in dataList"
                         :key="dataItem.id" @click="viewItem(dataItem)">

                        <div class="inner flexLayout" data-note="弹性布局">
                            <div style="width: 124px">
                                <div class="imageArea roundBorder8 w100p hiddenOverflow" style="height: 78px;"
                                     data-note="imageArea 内容为空时，有 #EEE 背景">
                                    <img class="cover fullSpace" :src="dataItem.coverImg" v-if="dataItem.coverImg"
                                         data-note="fullSpace 使用整个容器尺寸，cover 应用放大覆盖。" />
                                </div>
                            </div>
                            <div class="flexItem paddingL8">
                                <div class="titleArea font14r grey20 bold lineHeight21r14f" style="margin-bottom: 16px;"
                                     data-note="1.5 倍行高">
                                    {{dataItem.title}}
                                </div>

                                <div class="font12r grey marginT16">{{dataItem.teacherName}}</div>

                                <div class="clearfix font12r marginT16">
                                    <div class="fl bold grey20">
                                        <span class="red">￥</span>
                                        <span class="red font16r12">
<!--                                            <template v-if="dataItem.chargeMode=='FREE'">0</template>-->
                                            <!--                                            <template v-else>{{dataItem.price}}</template>-->
                                            {{dataItem.price}}
                                        </span>
                                        <span v-show="dataItem.liveCount">
                                            /共{{dataItem.liveCount}}节
                                        </span>
                                    </div>
                                    <div class="learningArea fr grey20">
                                        {{dataItem.applicantCount + dataItem.applicantCountSham}}人在学
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>
                </div><!-- end .list -->

                <div class="font14r alignC" style="line-height: 34px; color: #B7B6B5;"
                     @click="loadNextPage()" v-show="status=='ready' && pagination.current < pagination.totalPage">点击加载更多&gt;
                </div>

                <div class="font14r grey999" v-if="status==='error'">数据加载失败</div>

                <div class="alignCenter colorCCC bold" v-show="status == 'ready' && dataList.length < 1">
                    <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" />
                </div>

            </div>


        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";

const config = {
    name : 'zhiye_jineng_list',
    title : '职业技能',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/courseVod/listForAudience',
            params:{
                categoryFirstId:'',
                categorySecondId:'',
                categoryThirdId:'',
            },
            dataPath : 'data.rows',
            totalPath : 'data.totalCount',
            totalPagePath : 'data.totalPage'
        },
        get : {
            url : 'portal/tag/get'
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            // pageSize : 8,
            enableDataList : true,

            enableDataItem : true,
            autoLoadDataItem : true,
        }
    },
    methods : {
        onLoadDataItem() {
            this.apiConfig.list.params.categoryFirstId = this.dataItem.skipParam[0] || '';
            this.apiConfig.list.params.categorySecondId = this.dataItem.skipParam[1] || '';
            this.apiConfig.list.params.categoryThirdId = this.dataItem.skipParam[2] || '';
            this.reloadDataList();
        },
        viewItem(dataItem) {
            appHelper.goToPage('courseDetail', {
                id : dataItem.id
            });
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {
                return {
                    id : index,
                    title : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                    coverImg : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomCoverImage(),
                    createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7)
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.searchIcon {
    width: 18px;
    height: 19px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}
.list {
    .item {
        &:last-child {
            margin-bottom: 0;
        }
    }
    .titleArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .descArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 16px;
    }
}
</style>
